import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { ReactComponent as ArrowUpIcon } from "components/Icons/arrow-up.svg";
import { OLTheme } from "contexts/Theme/ThemeProvider";

const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    increase: {
      color: theme.green500,
      "& svg": { fontSize: 9 },
    },
    decrease: {
      color: theme.red500,
      "& svg": {
        fontSize: 9,
        transform: "rotate(180deg)",
      },
    },
    marginLeft: { marginLeft: theme.spacing(4) },
  }),
);
type Props = {
  className?: string;
  increase: number;
  text?: string;
};
export function PercentageIncrease({ className = "", increase, text }: Props) {
  const classes = useStyles();
  return (
    <>
      {text && <span>{text}</span>}

      <span
        className={`${increase > 0 ? classes.increase : classes.decrease} ${
          text && classes.marginLeft
        } ${className}`}
      >
        <ArrowUpIcon />
        {increase}%
      </span>
    </>
  );
}
